import React from 'react';
import md5 from 'md5';
import _ from 'lodash';
import moment from 'moment';

import numberformatter from '../../lib/customNumberFormatter';

class ColumnTableWidget extends React.Component {

    static isInt(value) {
        return !isNaN(value) && (x => (x || 0) === x)(parseFloat(value));
    }

    static numberFormatter(value) {
        return value.toFixed(0);
    }

    static getThirdColumn(type) {
        if (_.includes(['bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings'], type)) return 'Möten';
        if (_.includes(['createdActivities', 'activities', 'completedActivities', 'planedActivities'], type)) return 'Aktiviteter';
        if (_.includes(['opportunities', 'createdOpportunities'], type)) return 'Affärsmöjlighet';

        return 'Försäljning';
    }

    static shouldHaveFourthColumn(type) {
        if (_.includes(['activities', 'createdActivities', 'completedActivities', 'planedActivities',
                        'bookedMeetings', 'meetings', 'completedMeetings', 'planedMeetings'], type)) return false;
        return true;
    }

    oldRender() {
        const { widget, widgetData, companyProfile, currency } = this.props;

        const data = _.sortBy(widgetData, 'value').reverse();

        let budget;

        if (widget.displayConfig && widget.displayConfig.budget) {
            if (widget.displayConfig.budget != null || 0 || '') {
                budget = parseInt(widget.displayConfig.budget, 10);
            }
        }

        const rows = _.map(data, o => ({
            name: o.name,
            hash: md5(o.email),
            value: o.value,
            total: o.totalNumber,
            budget: budget || o.budget,
            percent: Math.floor((o.value / (budget || o.budget)) * 100) > 100 ?
                    100 : Math.floor((o.value / (budget || o.budget)) * 100),
        }));

        const style = {
            color: companyProfile.colors.mainBg,
        };

        const budgetAchieved = {
            star: {
                color: '#FFD700',
            },
        };

        const shouldScroll = 'table-row';

        if (_.inRange(widget.height, 1, 10) && rows.length > 5) {
            rows.splice(5, rows.length - 5);
        } else if (_.inRange(widget.height, 11, 15) && rows.length > 10) {
            rows.splice(10, rows.length - 10);
        }

        const table = [];

        if (_.includes(['activities', 'createdActivities', 'completedActivities', 'planedActivities', 
                        'bookedMeetings', 'meetings','completedMeetings', 'planedMeetings'], widget.dataType)) {
            for (let i = 0; i < rows.length; i += 1) {
                const currentRow = rows[i];
                const value = typeof currentRow.value === 'string' ? 0 : currentRow.value;

                table.push(
                    <li className={currentRow.percent >= 100 && currentRow.budget !== 0 ? 'budget_achieved_table' : ''} key={i}>
                        <span style={style}>
                            {currentRow.percent >= 100 && currentRow.budget !== 0
                                ? <i className="fa fa-star" style={budgetAchieved.star} />
                                : i + 1 }
                        </span>
                        <span>
                            {currentRow.name}
                        </span>
                        <span>
                            {`${numberformatter.fixThousands(value.toFixed(0))}`}
                        </span>
                    </li>,
                );
            }
        } else {
            for (let i = 0; i < rows.length; i += 1) {
                const currentRow = rows[i];
                const value = typeof currentRow.value === 'string' ? 0 : currentRow.value;

                table.push(
                    <li className={currentRow.percent >= 100 && currentRow.budget !== 0 ? 'budget_achieved_table' : ''} key={i}>
                        <span style={style}>
                            {currentRow.percent >= 100 && currentRow.budget !== 0
                                ? <i className="fa fa-star" style={budgetAchieved.star} />
                                : i + 1 }
                        </span>
                        <span>
                            {currentRow.name}
                        </span>
                        <span>
                            {`${numberformatter.fixThousands(value.toFixed(0))} ${currency}`}
                        </span>
                        <span>
                            {currentRow.total}
                        </span>
                    </li>,
                );
            }
        }

        return (
            <div className="table">
                <ul className={shouldScroll}>
                    <li className="table-head">
                        <span>#</span>
                        <span>Användare</span>
                        <span>{ColumnTableWidget.getThirdColumn(widget.dataType)}</span>
                        {ColumnTableWidget.shouldHaveFourthColumn(widget.dataType) &&
                            <span>Antal</span>}
                    </li>
                    {table}
                </ul>
            </div>
        );
    }

    newRender() {
        const { widget, widgetData } = this.props;

        // Always fill the table with at least one row to get the header to not be in the middle.
        const defaultWidgetData = widgetData.length ? widgetData : [{}];

        let shortenedWidgetData;

        if (widget.height < 11) {
            shortenedWidgetData = _.take(defaultWidgetData, 5);
        } else if (widget.height < 16) {
            shortenedWidgetData = _.take(defaultWidgetData, 10);
        } else {
            shortenedWidgetData = defaultWidgetData;
        }

        const rows = shortenedWidgetData.map(row =>
            widget.displayConfig.columns.reduce((result, column) =>
                Object.assign({}, result, { [column.field]: _.get(row, column.field) }), {}));

        const table = rows.map((row, i) => {
            const columns = _.map(row, (property, index) => {
                if (ColumnTableWidget.isInt(property)) {
                    return (
                        <span key={index}>
                            {numberformatter.fixThousands(parseInt(property, 10))}
                        </span>
                    );
                }

                return <span key={index}>{property}</span>;
            });

            return (
                <li className={row.percent >= 100 ? 'budget_achieved_table' : ''} key={i}>
                    {columns}
                </li>
            );
        });

        const headers = widget.displayConfig.columns.map(column =>
            <span key={column.field}>{column.label}</span>);

        return (
            <div className="table">
                <ul className="table-row">
                    <li className="table-head">
                        {headers}
                    </li>
                    {table}
                </ul>
            </div>
        );
    }

    renderFormSubmits() {
        const { widget, widgetData } = this.props;

        // Always fill the table with at least one row to get the header to not be in the middle.
        const defaultWidgetData = widgetData.length ? widgetData : [{id: 0, date: moment(), contact: 'Ingen data'}];

        let shortenedWidgetData;

        if (widget.height < 11) {
            shortenedWidgetData = _.take(defaultWidgetData, 5);
        } else if (widget.height < 16) {
            shortenedWidgetData = _.take(defaultWidgetData, 10);
        } else {
            shortenedWidgetData = defaultWidgetData;
        }

        const table = shortenedWidgetData.map((row) => {
            return (
                <li key={row.id}>
                    <span>{moment(row.date).format('YYYY-MM-DD HH:mm')}</span><span>{row.contact}<br /><i>{row.client}</i></span><span>{row.formName}</span>
                </li>
            );
        });

        return (
            <div className="table">
                <ul className="table-row">
                    <li className="table-head">
                        <span>Datum</span><span>Kontakt/Företag</span><span>Formulär</span>
                    </li>
                    {table}
                </ul>
            </div>
        );
    }

    renderVisits() {
        const { widget, widgetData } = this.props;

        // Always fill the table with at least one row to get the header to not be in the middle.
        const defaultWidgetData = widgetData.length ? widgetData : [{sourceVisits: 1, totalVisits:1}];
        let shortenedWidgetData;

        if (widget.height < 11) {
            shortenedWidgetData = _.take(defaultWidgetData, 5);
        } else if (widget.height < 16) {
            shortenedWidgetData = _.take(defaultWidgetData, 10);
        } else {
            shortenedWidgetData = defaultWidgetData;
        }

        let table;
        if (widget.dataType === 'topLeadSourceVisits') {
            table = shortenedWidgetData.map((row, i) => {
                return (
                    <li key={i+1}>
                        <span>{i+1}</span><span>{row.leadSource}</span><span>{_.round(100*row.sourceVisits/row.totalVisits, 2)}%</span>
                    </li>
                );
            });
        } else {
            table = shortenedWidgetData.map((row, i) => {
                return (
                    <li key={i+1}>
                        <span>{i+1}</span><span>{row.pageName}</span><span>{row.visits}</span>
                    </li>
                );
            });
        }

        let heading;
        if (widget.dataType === 'topLeadSourceVisits') {
            heading = (<li className="table-head"><span>#</span><span>Lead-källa</span><span>Procent av besök</span></li>)
        } else {
            heading = (<li className="table-head"><span>#</span><span>Sidnamn</span><span>Antal besök</span></li>)
        }

        return (
            <div className="table">
                <ul className="table-row">
                    {heading}
                    {table}
                </ul>
            </div>
        );
    }

    render() {
        if (this.props.isThumbnail) {
            return (<div className="table" />);
        } else if (_.has(this.props.widget, 'displayConfig.columns')) {
            return this.newRender();
        } else if (this.props.widget.dataType === 'forms') {
            return this.renderFormSubmits();
        } else if (_.includes(['topLeadSourceVisits','topViewsVisits'], this.props.widget.dataType)) {
            return this.renderVisits();
        }
        return this.oldRender();
    }
}

ColumnTableWidget.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    currency: React.PropTypes.string,
};

export default ColumnTableWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/ColumnTableWidget.jsx
 **/